import { actionSetDetailsValueByKey } from '..';

export const setDetailsValueByKey = (key, value) => actionSetDetailsValueByKey(key, value);